var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"holidayguru"},[_c('div',{class:`hg-navbar-container ${_vm.navBorder ? 'hg-navbar-container__border' : ''}`},[_c('HgNavbar',{staticClass:"hg-navbar",style:(_vm.navbarStyle),attrs:{"lang":_vm.lang,"isMounted":_vm.mounted,"showBookmarkButton":false,"showUserButton":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }